import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterIds,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleChangeSortBy,
  handleSetSelectedFilterValue,
  handleSetPublishRateValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { telegramFiltersInitialState } from './initialState/telegramInitialState';

export { telegramFiltersInitialState as filtersInitialState };

export const telegramSearchResourceInitialState = {
  filters: telegramFiltersInitialState,
  sortBy: {
    selected: 'member_count',
    order: 'desc',
  },
  selectedFilter: 'contentBasedFilter',
};
export const telegramSearchResourceSlice = createSlice({
  name: 'telegramSearchResourceSlice',
  initialState: telegramSearchResourceInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, telegramFiltersInitialState);
    },
    setPublishRateValue: (state, action) => {
      handleSetPublishRateValue(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = telegramFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, telegramFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedContentBasedValues,
  setSelectedFilterValue,
  setPublishRateValue,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = telegramSearchResourceSlice.actions;
